import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthService } from '../../services/auth.service';

import { login, loginSuccess, loginFailure, register, registerSuccess, registerFailure, logout, logoutSuccess, logoutFailure, updateUser } from './auth.actions';
import { clearSubscriptionData } from '../subscription/subscription.actions';
import {SubscriptionService} from "../../services/subscription.service";
import {BillingService} from "../../services/billing.service";
import {Store} from "@ngrx/store"; // Adjust the path as needed

import {hubspotLogout, hubspotLogoutFailure, hubspotLogoutSuccess} from "../oauth/oauth.actions";
import {HubspotService} from "../../services/hubspot.service";
import {UserService} from "../../services/user.service"; // Adjust the path as needed

@Injectable()
export class AuthEffects {

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),
      // tap(() => console.log('Login effect triggered')),
      switchMap(({ email, password }) =>
        this.authService.login(email, password).pipe(
          // tap(() => console.log('Calling login service', email)),
          map(response => {
            if (!response || !response.token || !response.user) {
              // If the response object is not structured as expected, throw an error
              throw new Error('Invalid login response');
            }
            // console.log('Login successful', response.token, response.user);
            return loginSuccess({ token: response.token, user: response.user });
          }),
          catchError(error => {
            console.log('Login failed', error);
            return of(loginFailure({ error }));
          })
        )
      )
    )
  );

  register$ = createEffect(() =>
    this.actions$.pipe(
      ofType(register),
      // tap(() => console.log('Register effect triggered')),
      switchMap(({ name, email, linkedin_url, country_id, company_invoice, company_name, company_identifier, company_country_id, company_county, company_town, company_zip_code, company_address, is_tax_payer, password, password_confirmation,search_id, event }) =>
        this.authService.register(name, email, linkedin_url, country_id, company_invoice, company_name, company_identifier, company_country_id, company_county, company_town, company_zip_code, company_address, is_tax_payer, password, password_confirmation,search_id, event).pipe(
          // tap(() => console.log('Calling register service', email)),
          map(response => {
            if (!response || !response.user) {
              // If the response object is not structured as expected, throw an error
              throw new Error('Invalid register response');
            }
            // console.log('Register successful', response.user);
            return registerSuccess({ user: response.user });
          }),
          catchError(error => {
            console.log('Register failed', error);
            return of(registerFailure({ error }));
          })
        )
      )
    )
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(logout),
      // tap(() => console.log('Logout effect triggered')),
      switchMap(() =>
        this.authService.logout().pipe(
          tap(() => {
            // Clear user data and reset state here
            // console.log('Calling logout service')
            this.store.dispatch(clearSubscriptionData());  // Action to reset user data in the store
          }),
          map(response => {
            if (!response) {
              // If the response object is not structured as expected, throw an error
              throw new Error('Invalid logout response');
            }
            // console.log('Logout successful', response);
            return logoutSuccess();
          }),
          catchError(error => {
            console.log('Logout failed', error);
            return of(logoutFailure(error));
          })
        )
      )
    )
  );

  /*
  updateUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateUser),
      tap(() => console.log('Update user effect triggered')),
      switchMap(({ user }) =>
        this.userService.updateUser(user).pipe(
          tap(() => console.log('Calling update user service', user)),
          map(response => {

            console.log("response",response)
            if (!response || !response.user) {
              // If the response object is not structured as expected, throw an error
              throw new Error('Invalid update user response');
            }
            console.log('Update user successful', response.user);
            return updateUserSuccess({  user: response.user });
          }),
          catchError(error => {
            console.log('Update user failed', error);
            return of(updateUserFailure({ error }));
          })
        )
      )
    )
  );
  */

  constructor(private actions$: Actions, private authService: AuthService, private userService:UserService, private store: Store) {}

}
